import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import "../../styles/fonts.css";
const CollectionVideo = ({ video, coll }) => {
  return (
    <Fragment>
      {video.url && video.url.length < 30 && (
        <div className='card col-xl-3 col-lg-4 m-2 col-md-4 col-12'>
          <Link
            to={`/${
              coll === "academics"
                ? "acad"
                : coll === "youtube"
                ? "youtube"
                : "extra"
            }/videos/${video.id}`}
            className='text-dark'
          >
            <img
              src={`https://img.youtube.com/vi/${video.url}/0.jpg`}
              className='card-img'
              alt='...'
            />

            <div className='card-body'>
              <h4 className='card-title fontcool text-center'>{video.name}</h4>
              <p>
                <span className='blue-grey-text text-lighten-2'>
                  {video.date &&
                    moment(video.date.toDate()).format(
                      "MMMM Do YYYY, HH:MM"
                    )}{" "}
                </span>
              </p>
              <p className='card-text simplefont text-center'>
                {video.description}
              </p>
              <p className='card-text text-right slantfont'>{video.author}</p>
            </div>
          </Link>
        </div>
      )}
    </Fragment>
  );
};

export default CollectionVideo;
